function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Business_ic_mid"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.88 96a2 2 0 01-2-2V72H16A16 16 0 010 56V16A16 16 0 0116 0h72a16 16 0 0116 16v22h-4V16A12 12 0 0088 4H16A12 12 0 004 16v40a12 12 0 0012 12h5.88a2 2 0 012 2v18.92l18.89-20.28a2 2 0 011.46-.64H58v4H45.11L23.35 95.36a2 2 0 01-1.47.64z",
  fill: "#666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.12 136a2 2 0 01-1.41-.58L113.17 112H72a16 16 0 01-16-16V52a16 16 0 0116-16h72a16 16 0 0116 16v44a16 16 0 01-16 16h-3.88v22a2 2 0 01-2 2zM72 40a12 12 0 00-12 12v44a12 12 0 0012 12h42a2 2 0 011.41.58l20.71 20.61V110a2 2 0 012-2H144a12 12 0 0012-12V52a12 12 0 00-12-12z",
  fill: "#666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134 64H82a2 2 0 110-4h52a2 2 0 110 4zM134 88H82a2 2 0 110-4h52a2 2 0 010 4z",
  fill: "#e60000"
})));

var SvgTextMid = function SvgTextMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 136",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgTextMid;